import SizeInputs from '@anm/components/SizeInputs';
import RadioButton from '@anm/components/form/RadioButton';

import { SectionSubTitle } from '../../../Wrapper';

import {
  SizeControlsWrapper,
  SizeFieldWrapper,
  SizeInputsWrapper,
  VideoSizeWrapper
} from './Wrapper';
import { useVideoSizes } from './hooks';

import {
  EmbedSizeType,
  hostedVideoSelectors,
  EmbedData
} from '../../../../../../store/modules/hostedVideo';

import { FC } from 'react';

import { useSelector } from 'react-redux';

type EmbedSizesInnerProps = EmbedSizesWrapper & {
  embedData: EmbedData;
};

type EmbedSizesWrapper = {
  title?: string;
};

const EmbedSizes: FC<EmbedSizesInnerProps> = ({
  embedData,
  title = 'Video size'
}) => {
  const [
    sizes,
    setSizes,
    selectedSizeType,
    setSelectedSizeType
  ] = useVideoSizes(embedData);

  const isSelectedResponsive = selectedSizeType === 'responsive';

  return (
    <VideoSizeWrapper>
      <SectionSubTitle {...{ title }} level={4} />
      <SizeControlsWrapper>
        <SizeFieldWrapper>
          <RadioButton<EmbedSizeType>
            value="fixed"
            name="video-size"
            label="Fixed size"
            isChecked={!isSelectedResponsive}
            onChange={setSelectedSizeType}
          />
          <SizeInputsWrapper>
            <SizeInputs sizes={sizes} keepProportion onChange={setSizes} />
          </SizeInputsWrapper>
        </SizeFieldWrapper>
      </SizeControlsWrapper>
      <SizeFieldWrapper>
        <RadioButton<EmbedSizeType>
          name="video-size"
          value="responsive"
          label="Responsive"
          isChecked={isSelectedResponsive}
          onChange={setSelectedSizeType}
        />
      </SizeFieldWrapper>
    </VideoSizeWrapper>
  );
};

const EmbedSizesWrapper: FC<EmbedSizesWrapper> = ({ title }) => {
  const embedData = useSelector(hostedVideoSelectors.selectEmbedData);

  if (!embedData) return null;

  return <EmbedSizes {...{ title, embedData }} />;
};

export default EmbedSizesWrapper;
